module.exports = __webpack_public_path__ + "img/eboekhouden.5987dc65.jpg";